<ng-container [formGroup]="group()">
  <label [for]="id + '-tag'" i18n>Tag:</label>
  <input [id]="id + '-tag'" type="text" formControlName="tag" [attr.disabled]="true">

  <label [for]="id + '-title'" i18n>Name:</label>
  <input [id]="id + '-title'"
         name="title"
         type="text"
         [formControl]="name()"
         (blur)="validate($any($event.target))">

  @if (adminForm().length) {
    <app-admin-config class="admin-form"
                      [group]="group()"
                      [fields]="adminForm()" />
  } @else {
    <ng-container *ngTemplateOutlet="jsonEditors" />
  }

  @if (adminForm().length || advancedAdminForm().length) {
    <details class="advanced admin-advanced" [open]="!!adminForm().length && jsonErrors()">
      <summary><span i18n>Advanced</span></summary>
      <div class="form">
        @if (advancedAdminForm().length) {
          <app-admin-config class="advanced-admin-form"
                            [group]="group()"
                            [fields]="advancedAdminForm()" />
        }
        @if (adminForm().length) {
          <ng-container *ngTemplateOutlet="jsonEditors" />
        }
      </div>
    </details>
  }

  <details class="advanced form-builder" (toggle)="formBuilderOpen.set($any($event.target).open)">
    <summary><span i18n>Form Builder</span></summary>
    @if (formBuilderOpen()) {
      <div class="form">
        <app-admin-config class="form-builder-form"
                          [group]="group()"
                          [fields]="formBuilder" />
        <span><!-- Buttons --></span>
        <div class="form-builder-actions">
          <button type="button"
                  class="generate-schema"
                  (click)="generateSchema()"
                  i18n-title
                  title="Replace the schema with one generated from the form"
                  i18n>Generate Schema</button>
          <button type="button"
                  class="generate-defaults"
                  (click)="generateDefaults()"
                  i18n-title
                  title="Add default values for new fields and remove defaults for deleted fields"
                  i18n>Generate Defaults</button>
        </div>
        @if (defaultsForm().length) {
          <span><!-- Title --></span>
          <h3 class="defaults-title" i18n>Default Values</h3>
          <app-admin-config class="defaults-form"
                            fieldName="defaults"
                            [group]="group()"
                            [fields]="defaultsForm()" />
        }
      </div>
    }
  </details>

  <ng-template #jsonEditors>
    <label [for]="id + '-config'" i18n>Config:</label>
    @if (!editingConfig() && !config()) {
      <div>
        <button type="button" (click)="editingConfig.set(true)" i18n>+ Add Config</button>
      </div>
    } @else {
      <app-json (focusin)="editingConfig.set(true)" [id]="id + '-config'"
                name="config"
                fieldName="config"
                [group]="group()" />
      @if (configErrors().length) {
        <span><!-- Errors --></span>
        @for (e of configErrors(); track e) {
          <div>
            <span class="error">{{ e }}</span>
          </div>
        }
      }
    }

    <label [for]="id + '-defaults'" i18n>Defaults:</label>
    @if (!editingDefaults() && !defaults()) {
      <div>
        <button type="button" (click)="editingDefaults.set(true)" i18n>+ Add Defaults</button>
      </div>
    } @else {
      <app-json (focusin)="editingDefaults.set(true)" [id]="id + '-defaults'"
                fieldName="defaults"
                [group]="group()" />
      @if (defaultsErrors().length) {
        <span><!-- Errors --></span>
        @for (e of defaultsErrors(); track e) {
          <div>
            <span class="error">{{ e }}</span>
          </div>
        }
      }
    }

    <label [for]="id + '-schema'" i18n>Schema:</label>
    @if (!editingSchema() && !schema()) {
      <div>
        <button type="button" (click)="editingSchema.set(true)" i18n>+ Add Schema</button>
      </div>
    } @else {
      <app-json (focusin)="editingSchema.set(true)" [id]="id + '-schema'"
                fieldName="schema"
                [group]="group()" />
      @if (schemaErrors().length) {
        <span><!-- Errors --></span>
        @for (e of schemaErrors(); track e) {
          <div>
            <span class="error">{{ e }}</span>
          </div>
        }
      }
    }
  </ng-template>
</ng-container>
